export default __webpack_public_path__ + "static/media/customer-service.b7cac6e7.svg";